import DataGrid from "./DataGrid/DataGrid.tsx";

const AgentsDataGrid = ({ agentsList, isLoading }) => {
  const columns = [
    { name: "agentID", header: "ID", type: "string" },
    {
      name: "agentName",
      header: "Име на агент",
      type: "string",
    },
    {
      name: "phone",
      header: "Телефонен номер",
      type: "string",
    },
    { name: "address", header: "Адрес", type: "string" },
    {
      name: "personalIdentificationNumber",
      header: "ЕГН",
      type: "string",
    },
    { name: "idCardNumber", header: "№ ЛК", type: "string" },
    {
      name: "isActive",
      header: "Активен",
      type: "bool",
      render: ({ data }) => (data.isActive ? "Да" : "Не"),
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={agentsList}
      isLoading={isLoading}
      gridTitle="Агенти"
      idProperty="agentID"
      csvFilename="agents.csv"
      onEditComplete={undefined}
    />
  );
};

export default AgentsDataGrid;
